module.exports = __webpack_public_path__ + "static/media/clock.9e7a1a4a.svg";